/*
 * Utilities for type coercion and manipulation
 */

import { Simplify } from 'type-fest';

/**
 * Implementing our own SetOptional instead of using the one in type-fest,
 * because intellij doesn't like the one in type-fest:
 *
 * https://youtrack.jetbrains.com/issue/IDEA-363763
 */
export type SetOptional<BaseType, Keys extends keyof BaseType> = Simplify<
  Omit<BaseType, Keys> & Partial<Pick<BaseType, Keys>>
>;

export function isDefined<T>(x?: T): x is NonNullable<T> {
  return x !== undefined && x !== null;
}

export type KnownProperties<T> = Record<keyof T, true>;

export function onlyProperties<T extends NonNullable<unknown>>(
  properties: KnownProperties<T>,
  value: T,
): T {
  return <T>(
    Object.fromEntries(
      Object.entries(value).filter(([key]) => properties[key as keyof T]),
    )
  );
}

export type LoosePick<T, K extends keyof T> = Pick<T, K> &
  Partial<{ [k in keyof Omit<T, K>]: undefined }>;
